import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export function getSelectedCalendars() {
    const selectedCalendars = getUserConfiguration().ViewStateConfiguration
        .SelectedCalendarsDesktop;
    return selectedCalendars ? selectedCalendars : [];
}

export function getShowDeclinedMeetingsEnabled(): boolean {
    return getUserConfiguration().ViewStateConfiguration.CalendarViewShowDeclinedMeetings;
}
